import React, { useState, useEffect } from "react";
import { db } from "../../../../assets/firebase/firebaseconfig";
import { ref, get, push, remove, update, onValue } from "firebase/database";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "../ProjectManager/styles.css";
import "./styles.css";

const NewsManager = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingNews, setEditingNews] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [quillKey, setQuillKey] = useState(0);

  // Danh mục khớp 100% với trang News chính
  const categories = [
    "Tin công ty",
    "Kiến thức chuyên ngành",
    "Công nghệ mới",
    "Sự kiện",
  ];

  const [formData, setFormData] = useState({
    title: "",
    category: "Tin công ty",
    summary: "", // Đây là sapo hiển thị ở trang chủ
    content: "",
  });

  const [file, setFile] = useState(null);
  const CLOUD_NAME = "dseiy70jw";
  const UPLOAD_PRESET = "habakome";

  useEffect(() => {
    const newsRef = ref(db, "news");
    onValue(newsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setNews(list);
      } else {
        setNews([]);
      }
    });
  }, []);

  const uploadMedia = async (file) => {
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", UPLOAD_PRESET);
    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/upload`,
      {
        method: "POST",
        body: data,
      }
    );
    const result = await res.json();
    return result.secure_url;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Đổi tên từ imageUrl thành image cho khớp News.js
      let image = editingNews ? editingNews.image : "";
      if (file) image = await uploadMedia(file);

      const newsData = {
        title: formData.title,
        category: formData.category,
        summary: formData.summary,
        content: formData.content,
        image: image, // Đã đổi tên trường
        updatedAt: Date.now(),
      };

      if (editingNews) {
        await update(ref(db, `news/${editingNews.id}`), newsData);
        alert("Cập nhật tin tức thành công!");
      } else {
        await push(ref(db, "news"), { ...newsData, createdAt: Date.now() });
        alert("Đăng tin tức thành công!");
      }
      closeModal();
    } catch (error) {
      console.error(error);
      alert("Lỗi khi lưu bài viết!");
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setShowAddModal(false);
    setEditingNews(null);
    setFormData({
      title: "",
      category: "Tin công ty",
      summary: "",
      content: "",
    });
    setFile(null);
    setQuillKey((prev) => prev + 1);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Xác nhận xóa bài viết này?")) {
      await remove(ref(db, `news/${id}`));
    }
  };

  const filteredNews = news
    .filter((n) =>
      (n.title?.toLowerCase() || "").includes(searchTerm.toLowerCase())
    )
    .sort((a, b) =>
      sortOrder === "asc"
        ? a.createdAt - b.createdAt
        : b.createdAt - a.createdAt
    );

  return (
    <div className="admin-content-inner">
      <div className="page-header">
        <h1>QUẢN LÝ TIN TỨC</h1>
      </div>

      <div className="filter-section card">
        <div className="filter-bar-container">
          <div className="search-box">
            <input
              type="text"
              placeholder="Tìm kiếm tiêu đề bài viết..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="sort-box">
            <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              className="sort-select"
            >
              <option value="desc">Mới nhất trước</option>
              <option value="asc">Cũ nhất trước</option>
            </select>
          </div>
          <button className="btn-add-new" onClick={() => setShowAddModal(true)}>
            + Soạn bài viết mới
          </button>
        </div>
      </div>

      <div className="table-section card">
        <table className="main-table">
          <thead>
            <tr>
              <th>ẢNH</th>
              <th>THÔNG TIN BÀI VIẾT</th>
              <th>TÓM TẮT (SAPO)</th>
              <th>THAO TÁC</th>
            </tr>
          </thead>
          <tbody>
            {filteredNews.map((item) => (
              <tr key={item.id}>
                <td>
                  <img
                    src={item.image}
                    alt="news"
                    className="table-img-preview"
                  />
                </td>
                <td>
                  <div className="info-cell">
                    <span className="main-name">{item.title}</span>
                    <span className="sub-tag">{item.category}</span>
                  </div>
                </td>
                <td>
                  <p className="table-desc-short">{item.summary}</p>
                </td>
                <td>
                  <div className="action-btns">
                    <button
                      className="btn-edit-tool"
                      onClick={() => {
                        setEditingNews(item);
                        setFormData(item);
                        setShowAddModal(true);
                      }}
                    >
                      Sửa
                    </button>
                    <button
                      className="btn-delete-tool"
                      onClick={() => handleDelete(item.id)}
                    >
                      Xóa
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>{editingNews ? "CẬP NHẬT BÀI VIẾT" : "SOẠN TIN TỨC MỚI"}</h3>
              <button className="btn-close" onClick={closeModal}>
                &times;
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Tiêu đề bài viết"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                  required
                />
              </div>

              <div className="form-group">
                <select
                  value={formData.category}
                  onChange={(e) =>
                    setFormData({ ...formData, category: e.target.value })
                  }
                  className="sort-select"
                  style={{ width: "100%", marginBottom: "10px" }}
                >
                  {categories.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <textarea
                  placeholder="Tóm tắt ngắn (Sapo) hiển thị ở danh sách tin"
                  value={formData.summary}
                  onChange={(e) =>
                    setFormData({ ...formData, summary: e.target.value })
                  }
                  style={{ width: "100%", padding: "10px", minHeight: "80px" }}
                  required
                />
              </div>

              <div className="form-group">
                <label>Nội dung chi tiết:</label>
                <ReactQuill
                  key={quillKey}
                  theme="snow"
                  value={formData.content}
                  onChange={(val) => setFormData({ ...formData, content: val })}
                />
              </div>

              <div className="form-group">
                <input
                  type="file"
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="btn-submit-form"
              >
                {loading ? "Đang xử lý..." : "LƯU BÀI VIẾT"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsManager;
